import dynamic from "next/dynamic";
const HubspotOnPurpleBackgroundFormComponent = dynamic(()=>import("./hubspot-on-purple-background-form-component"));
import HubspotOnPurpleBackgroundFormConfig from "./hubspot-on-purple-background-form-config";
import HubspotOnPurpleBackgroundFormAdvancedConfig from "./hubspot-on-purple-background-form-advanced-config";
export default {
    HubspotOnPurpleBackgroundFormComponent,
    HubspotOnPurpleBackgroundFormConfig,
    HubspotOnPurpleBackgroundFormAdvancedConfig
};
